import MySurveysTable, { ThElementsType } from "components/MySurveys/MySurveysTable";
import { useState } from "react";
import Pagination from "../Pagination/Pagination";
import { dataHandler } from "./dataHandler";
import { useTranslation } from "react-i18next";
import { SkeletonRows } from "components/ui";

const ThColumns: ThElementsType = {
  scope: "col",
  classes: "",
  dataKeys: [
    { id: 1, column: "Survey Name", label: "studyName" },
    { id: 2, column: "Points", label: "points" },
    { id: 3, column: "Pid", label: "p_id" },
    { id: 4, column: "Date", label: "createdAt" },
    { id: 7, column: "Action", label: "actionFunction" },
  ],
};
const PanelistStudywiseTable = ({ studiesData, setClaimList, claimList, isLoading }: any) => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [recordsPerPage] = useState(10);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  // add to claim points list
  const claimAction = (survey) => {
    const isInClaimList = claimList.length ? claimList.some((data: any) => data._id === survey._id) : false;

    if (isInClaimList) {
      setClaimList((prevState) => prevState.filter((e) => e._id !== survey._id));
    } else {
      setClaimList((prevState) => [...prevState, survey]);
    }
  };
  //prepare data to enter
  const surveysSet = dataHandler({
    data: studiesData?.data,
    indexOfFirstRecord,
    indexOfLastRecord,
    actionFunction: claimAction,
    claimList,
  });

  if (isLoading) {
    return (
      <div>
        <span className="sr-only">{t("page.referral.Loading")}</span>
        <SkeletonRows rows={6} />
      </div>
    );
  }
  return (
    <div className="w-full">
      <MySurveysTable
        thElements={ThColumns}
        tdElements={surveysSet}
        searchQuery="searchQuery"
        tdDataStyle=""
        tdRowStyle=""
        tableStyle=""
        startIndex={indexOfFirstRecord}
      />
      <div className="zs-table-footer justify-center sm:justify-end">
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={Math.ceil(studiesData?.data?.length / 10)}
        />
      </div>
    </div>
  );
};

export default PanelistStudywiseTable;
